import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AdvertiseComp from "../../components/Advertisement/AdvertiseComp";

const AdvertisementsManagement = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Advertisements Management' />

                {/* GalleryLayer */}
                <AdvertiseComp />
            </MasterLayout>
        </>
    );
};

export default AdvertisementsManagement;
